import { useEffect, useState } from 'react';
import {
  RealtimeKitProvider,
  useRealtimeKitClient,
} from '@cloudflare/realtimekit-react';
import { RtkMeeting } from '@cloudflare/realtimekit-react-ui';
import RealtimeKitVideoBackgroundTransformer from '@cloudflare/realtimekit-virtual-background';
import { getRealtimeKitToken } from '../utils/api';
import './Meeting.css';

const getMeetingIdFromPath = () => {
  const segments = window.location.pathname
    .split('/')
    .filter(Boolean)
    .map((segment) => decodeURIComponent(segment));

  const meetingId = segments[segments.length - 1];
  return meetingId && meetingId !== 'lessons' ? meetingId : undefined;
};

const Meet = () => {
  const [meeting, initMeeting] = useRealtimeKitClient();
  const [meetingId, setMeetingId] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    const nextMeetingId = getMeetingIdFromPath();

    if (nextMeetingId) {
      setMeetingId(nextMeetingId);
    } else {
      window.location.href = 'https://poc.baodaotalk.com';
    }
  }, []);

  useEffect(() => {
    if (!meetingId) return undefined;

    let cancelled = false;

    const connect = async () => {
      try {
        const access = await getRealtimeKitToken(meetingId);

        if (!access?.token) {
          throw new Error('後端沒有回傳 RealtimeKit token。');
        }

        const nextMeeting = await initMeeting({
          authToken: access.token,
          defaults: {
            audio: false,
            video: false,
          },
          modules: {
            plugin: true,
            recording: Boolean(access.isEnableRecording),
            devTools: process.env.REACT_APP_NODE_ENV === 'local' && {
              logs: false,
              plugins: [
                {
                  name: 'BaoDaoTalk-note-editor',
                  port: 5000,
                  id: '1ca8c848-6068-4a2a-9d9c-b35579d421bb',
                },
              ],
            },
          },
        });

        if (cancelled) return;

        try {
          const transformer =
            await RealtimeKitVideoBackgroundTransformer.init({
              meeting: nextMeeting,
            });
          nextMeeting.self.addVideoMiddleware(
            await transformer.createBackgroundBlurVideoMiddleware(10)
          );
        } catch (backgroundError) {
          console.warn('RealtimeKit virtual background is unavailable.', backgroundError);
        }
      } catch (connectionError) {
        if (!cancelled) {
          setError(
            connectionError?.response?.status === 401
              ? '連線憑證已失效，請重新整理後再試。'
              : connectionError.message || '教室暫時無法建立連線。'
          );
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    connect();

    return () => {
      cancelled = true;
    };
  }, [initMeeting, meetingId]);

  if (error) {
    return <div className="meeting-error">{error}</div>;
  }

  if (isLoading || !meeting) {
    return <div className="meeting-loading">正在連線到教室…</div>;
  }

  return (
    <RealtimeKitProvider value={meeting}>
      <RtkMeeting mode="fill" meeting={meeting} />
    </RealtimeKitProvider>
  );
};

export default Meet;
